import React from 'react';
import ReactDOM from 'react-dom/client';
// import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import './i18n';
import ErrorBoundary from './ErrorBoundary/ErrorBoundary';
// import { BrowserRouter } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';

// TODO: visual glitch in the ViewMap component, not there in react 17,
// refer to:   // https://github.com/google-map-react/google-map-react/issues/1143

// Create the root container
const container = document.getElementById('root');

if (!container) {
  throw new Error('Root container missing in index.html');
}

const root = ReactDOM.createRoot(container);
root.render(
  <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID || ''}>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </GoogleOAuthProvider>
);
